module.exports = __webpack_public_path__ + "img/zhiwei.5042088d.svg";